// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I5RWz","toggle":"styles_toggle__1dY--","preview":"styles_preview__Msfpq"};